import React, { useContext, useState } from "react";
import style from "./FormOptions.module.css";
import {
  faMehRollingEyes,
  faBullseye,
  faEye,
  faEyeDropper,
  faEyeSlash,
  faCalendar,
  faCommentDots
} from "@fortawesome/free-solid-svg-icons";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import SettingsIcon from "@material-ui/icons/Settings";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToggleButtonGroup, ToggleButton, DropdownButton, Dropdown, ButtonGroup, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../Resources/CanvasContextFile";
import { downloadJson } from "../../../../Resources/globalFunctions";
import Eye from "../../../../Icons/header/eye";
import DownArrow1 from "../../../../Icons/DownArrow";
import dots from "../../../../Icons/header/3dots";
import MagicWand from "../../../../Icons/header/magicWand";
import Save from "../../../../Icons/header/save";
import Settings from "../../../../Icons/header/settings";
import DownArrow from "../../../../Icons/header/downArrowSmall";
import Cake from "../../../../Icons/header/cake";
import { useTranslation } from "react-i18next";
import { useDispatch, addContexts, useSelector } from "../../../../Redux";
import { makeStyles } from "@material-ui/core/styles";
import axios from "../../../../axios";
import { GetStateFromData } from "../../../CustomHooks/CustomHooks";
import { Tooltip } from "@material-ui/core";
// import { container } from 'webpack';

const useStyles = makeStyles(() => ({
  previewButton: {
    display: "flex",
    alignItems: "center",
    "&:hover": {
      textDecoration: "none"
    }
  },
  saveDropDown: {
    position: "absolute",
    // width:"150px",
    width: "0",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    top: "2em",
    left: "-9em",
    boxShadow: "0px 0px 6px #00000029",
    borderRadius: "2px",
    lineHeight: "36px",
    textAlign: "start",
    zIndex: "9",
    background: "#fff",
    color: "#000",
    padding: "0 !important",
    "&:focus": {
      padding: "6px 15px !important",
      width: "max-content",
      overflow: "unset"
    },
    "&:hover": {
      background: "#d6eeff"
    }
  },
  tooltip: {
    maxWidth: "260px",
    // maxHeight: "96px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12
    // marginTop: "0px",
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075"
    },
    color: "white",
    fontSize: 15
  }
}));

const FormOptions = (props) => {
  const classes = useStyles();
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";

  // const { updateJson, formState2 } = useContext(AppContext);
  const dispatch = useDispatch();
  const contexts = GetStateFromData(props.containerId);

  const {
    updateJson,
    containerId,
    formState2,
    microFrontendData,
    setFormState2,
    setFormBuillderMode,
    activeApplication,
    activeSubForm,
    activePage
  } = contexts.contexts;

  const { t } = useTranslation();

  const { saveFormState } = updateJson;

  let flag = 0;

  if (activeApplication !== undefined) {
    if (activeApplication.fragmentId && activeApplication.fragmentName) {
      flag = 1;
    } else if (
      activeApplication.existingFormId &&
      activeApplication.formId &&
      activeApplication.formPageType === "Portals"
    ) {
      flag = 1;
    } else if (activeApplication.formType && activeApplication.formName) {
      flag = 1;
    } else if (activeApplication.templatename && activeApplication.formType === undefined) {
      if (activeApplication.templatecategory === "PAGE" || activeApplication.templatecategory === "FORM") flag = 1;
    }
  }

  //console.log("Microfrontenddata Pmweb", containerId, window.location.href, window.location, window)

  const openPreviewPageHandler = () => {
    window.open("preview", "_blank");
    // window
    //   .open(
    //     "/preview",
    //     "_blank",
    //     "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes"
    //   );
  };

  // function handlePreview(){
  //     window.inPreview= true ;
  // }

  function handleApplicationPreview(e, activeApplication, url) {
    // if(url?.origin !== "" && containerId === "mf_forms_customise" && window.location.href.indexOf("processDesigner") > -1 ){
    //     // 👇️ setting target to _blank with window.open
    //     const url1 = `${url.origin}/psh/pmWebPreview`
    //     // window.newMicroFrontendData = {...microFrontendData, url1}
    //     // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
    //     var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`);
    //     newPreviewVar.newMicroFrontendData = {...microFrontendData, url1}
    // }
    // if(url?.origin !== "" && window.location.href.indexOf("pmWebDesigner") > -1 ){
    //     // 👇️ setting target to _blank with window.open
    //     const url1 = `${url.origin}/psh/pmWebPreview`
    //     // window.newMicroFrontendData = {...microFrontendData, url1}
    //     // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
    //     var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`);
    //     newPreviewVar.newMicroFrontendData = {...microFrontendData, url1}
    // }
    window.inPreview = true;
    handlePreview(url);
    // if (window.openApplicationPreview){
    //     window.callSpecifiedFunctions()
    //     window.openApplicationPreview(activeApplication);

    // }
    // if(microFrontendData?.currentPagePreview1 !== undefined && microFrontendData?.currentPagePreview1 !== {}){
    // delete microFrontendData.currentPagePreview1
    // }

    openApplicationPreview1(url);
  }

  async function openApplicationPreview1(url) {
    await window
      .callSpecifiedFunctions(activeApplication, "openApplicationPreview", url,true)
      .then((res) => {
        window.loading(false);
      })
      .catch((err) => {
        window.loading(false);
      });
    // if (window.openApplicationPreview){
    //     window.openApplicationPreview(activeApplication);

    // }
  }

  function handlePreview(url = "") {
    // saveFormState();

    window.inPreview = true;
    const viewformJson = {
      isApp: "false",
      DeviceType: "W",
      isGeneralDataCreated: false,
      isWIModelCreated: false,
      gdtoken: "TestProcess-0000000003-process_GeneralData",
      witoken: "",
      pid: "TestProcess-0000000003-process",
      wid: "1",
      tid: "",
      fid: "Form_TestProcess-0000000003-process_1",
      sessionInfo:
        '{"CabinetName":"ibps5sp2final","JTSIP":"1","JTSPORT":"8080","DMSSessionId":"375205739","AppServerType":"JBossEAP"}',
      formJson: JSON.stringify(formState2),
      isPreview: true
    };

    axios
      .post("viewform/", viewformJson, { withCredentials: true })
      .then((resp) => {
        setFormState2(formState2);
        setFormBuillderMode("preview");
        // dispatch(setFormState1(formBuffer));

        //set gdtoken and witoken in redux store so that others can use it
        var contextValues = resp.data.gdtoken;
        dispatch(addContexts({ key: containerId, name: "gdtoken", contextValues }));
        contextValues = resp.data.witoken;
        dispatch(addContexts({ key: containerId, name: "witoken", contextValues }));
      })
      .catch((err) => {
        setFormState2(formState2);
        console.log(err);
      });
    if (
      (url?.origin !== "" &&
        containerId === "mf_forms_int_des" &&
        window.location.href.indexOf("processDesigner") > -1 &&
        microFrontendData?.componentType === "TF") ||
      (url?.origin !== "" &&
        containerId === "mf_forms_int_des" &&
        window.location.href.indexOf("processDesigner") > -1 &&
        microFrontendData?.componentType === "GT")
    ) {
      window.callSpecifiedFunctions1(saveFormState, url);
      // if(url?.origin !== "" && containerId === "mf_forms_int_des" && window.location.href.indexOf("processDesigner") > -1 && microFrontendData?.componentType === "TF"){
      //     // 👇️ setting target to _blank with window.open
      //     const url1 = `${url.origin}/psh/pmWebPreview`
      //     // window.newMicroFrontendData = {...microFrontendData, url1}
      //     // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
      //     var newTaskFormPreview = window.open(`${url.origin}/psh/pmWebPreview`);
      //     newTaskFormPreview.newMicroFrontendData = {...microFrontendData}
      // }
      // if(url?.origin !== "" && containerId === "mf_forms_int_des" && window.location.href.indexOf("processDesigner") > -1 && microFrontendData?.componentType === "GT"){
      //     // 👇️ setting target to _blank with window.open
      //     // window.callSpecifiedFunctions1(saveFormState, url)
      //     const url1 = `${url.origin}/psh/pmWebPreview`
      //     // window.newMicroFrontendData = {...microFrontendData, url1}
      //     // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
      //     var newTaskFormPreview = window.open(`${url.origin}/psh/pmWebPreview`);
      //     newTaskFormPreview.newMicroFrontendData = {...microFrontendData}
      // }
    }
  }

  async function handlePagePreview() {
    window.inPreview = true;
    var data = {};
    if (activePage) {
      data = { ...activeApplication, page: { ...activePage } };
      // window.currentPagePreview = {...window.currentPageNew1}
      // delete window.currentPageNew1
    } else if (activeSubForm) {
      data = { ...activeApplication, subform: { ...activeSubForm } };
    }
    // saveFormState();
    await window
      .callSpecifiedFunctions(data, "OpenSelectedPagePreview",true)
      .then((res) => {
        window.loading(false);
      })
      .catch((err) => {
        window.loading(false);
      });
    // window.OpenSelectedPagePreview(data);
  }

  const handleKeyDown = (event) => {
    if (event.key == "Enter") {
      if (activeApplication) {
        handleApplicationPreview(event, activeApplication, window?.location);
      }
      if (containerId === "mf_forms_int_des") {
        handlePreview(window?.location);
      } else {
        handlePreview();
      }
    }
  };

  const handleKeyDown1 = (event) => {
    if (event.key == "Enter") {
      handlePagePreview();
    }
  };

  return (
    <Tooltip
      title={t(`translation:Preview`)}
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      placement={"bottom-start"}
      arrow
    >
      <div>
        <div className={style.previewLink} role="region" aria-label="Form Options">
          <div className={style.previewButton}>
            {activeApplication ? (
              <>
                <span
                  onKeyDown={(e) => (flag === 0 ? handleKeyDown1(e) : handleKeyDown(e))}
                  tabIndex={0}
                  className={style.previewBtnIconParent}
                  onClick={(e) =>
                    flag === 0 ? handlePagePreview() : handleApplicationPreview(e, activeApplication, window?.location)
                  }
                >
                  <div className={style.previewBtnIcon}>
                    <img
                      src={require("../../../../Icons/NavbarIcons/eye.svg").default}
                      value="preview"
                      alt="Preview Icon"
                    />
                  </div>
                  {flag === 1 && t("Preview")}
                </span>

                {flag === 0 && !activeSubForm && (
                  <span
                    onClick={() => {
                      document.querySelector("#preview_FocusableDiv_header")?.focus();
                    }}
                    style={{ margin: "0 5px", position: "relative", display: "flex", alignItems: "center" }}
                  >
                    <><DownArrow1 /><div
                        onClick={(e) => handleApplicationPreview(e, activeApplication, window?.location)}
                        onKeyDown={handleKeyDown}
                        tabIndex={0}
                        id="preview_FocusableDiv_header"
                        className={`${classes.previewButton} ${classes.saveDropDown}`}
                        style={translationStyles1 ? { left: "unset", right: "-9em" } : null}
                      >
                        <span className={style.previewBtnLabel} style={{ margin: "0 5px" }}>
                          {t("Application Preview")}
                        </span>
                      </div></>
                  </span>
                )}
              </>
            ) : (
              <>
                {containerId === "mf_forms_int_des" ? (
                  <div
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                    className={classes.previewButton}
                    onClick={() => handlePreview(window?.location)}
                  >
                    <div className={style.previewBtnIcon} style={{ margin: "0 5px" }}>
                      <img
                        src={require("../../../../Icons/NavbarIcons/eye.svg").default}
                        value="preview"
                        alt="Preview Icon"
                      />
                    </div>
                    {/* <div className={style.previewBtnLabel} style={{ margin: "0 5px" }}>
                      {t("Preview")}
                    </div> */}
                  </div>
                ) : (
                  <Link
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                    to={`/preview`}
                    className={classes.previewButton}
                    onClick={() => handlePreview()}
                  >
                    <div className={style.previewBtnIcon} style={{ margin: "0 5px" }}>
                      <img
                        src={require("../../../../Icons/NavbarIcons/eye.svg").default}
                        value="preview"
                        alt="Preview Icon"
                      />
                    </div>
                    {/* <div className={style.previewBtnLabel} style={{ margin: "0 5px" }}>
                      {t("Preview")}
                    </div> */}
                  </Link>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Tooltip>
  );
};

export default FormOptions;
